var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btb-loader p-3"},[_vm._t("default",function(){return [_c('div',{staticClass:"btb-loading"},[_c('span',{staticClass:"font-italic"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._l((_vm.dots),function(dot,idx){return _c('span',{key:dot,staticClass:"btb-loading-dot",style:(`--animation-delay: ${ idx }`)},[_vm._v(".")])})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }